import logger from '@vue-util/logger';
import $http from '@vue-util/http';

export const fetchProductById = async (productId) => {
  try {
    const url = `/xapi/digital/v1/product/${productId}`;
    const response = await $http.get(url);

    if (response.errors || response.Error) {
      throw new Error(response.errors ? response.errors.error[0].message : response.Error.message);
    }

    return response.data?.product?.[0];
  } catch (error) {
    logger.error(error);
    return {};
  }
};
